// Spec: specs/survey_editor/features/functional_requirements.md §Transport / "Prompt-drawing surfaces"

// lib
import React from 'react'
import PropTypes from 'prop-types'
import { Map } from 'immutable'

// One family across plans: a mark inside a message context carries the restrained sprite, while the
// filled one belongs to the standing sidebar panel.
const MESSAGE_CONTEXT_MARKS = {
  'self-serve-subscription': 'self-serve-small',
  'filled-atom': 'enterprise-small',
  'education-subscription': 'education-small',
  'flex-subscription': 'flex-small'
}

// <Component>
UpgradePackageMark.propTypes = {
  upgradePackage: PropTypes.instanceOf(Map),
  className: PropTypes.string,
  size: PropTypes.number,
  tinted: PropTypes.bool
}
// `tinted` draws the sprite as a font glyph, so the mark takes the surrounding chrome's colour
// instead of the brand artwork's - what the picker rows need to sit next to their sibling icons.
export default function UpgradePackageMark({ upgradePackage = Map(), className = '', size = 16, tinted } = {}) {
  const icon = upgradePackage.get('icon') || ''
  if (!icon) {
    return null // the Contact-Us variant carries identifiers only, and those never brand a prompt
  }

  const displayName = upgradePackage.get('displayName') || ''
  const mark = tinted ? null : MESSAGE_CONTEXT_MARKS[icon]

  return mark ? (
    <img
      className={className}
      src={`/images/subscriptions/package_icons/${mark}.svg`}
      alt={displayName}
      width={size}
      height={size}
    />
  ) : (
    <i className={`${className} icon-aytmfd-${icon}`} />
  )
}
